import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateOrderElementButtonProps } from "./create-order-element-button.interface";
import { type CreateOrderElementButton_CreateOrderElementMutation } from "../../../../__generated__/CreateOrderElementButton_CreateOrderElementMutation.graphql";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const CREATE_ORDER_ELEMENT_MUTATION = graphql`
	mutation CreateOrderElementButton_CreateOrderElementMutation($input: CreateOrderElementInput!) {
		Admin {
			ElearningV2 {
				createOrderElement(input: $input) {
					eLearningContentNode {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

export const CreateOrderElementButton = ({ eLearningContentId }: CreateOrderElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createOrderElement, isAddingOrderElement] =
		useMutation<CreateOrderElementButton_CreateOrderElementMutation>(
			CREATE_ORDER_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isAddingOrderElement}
			tooltip={t("educationalOffer.createOrderElementTooltip")}
			icon={EpicIcons.SORT_AMOUNT_DOWN}
			onClick={() => {
				createOrderElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							eLearningContentNodeId: eLearningContentId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
